import { render, staticRenderFns } from "./TableV1.vue?vue&type=template&id=11fa4d8c&scoped=true"
import script from "./TableV1.vue?vue&type=script&lang=js"
export * from "./TableV1.vue?vue&type=script&lang=js"
import style0 from "./TableV1.vue?vue&type=style&index=0&id=11fa4d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fa4d8c",
  null
  
)

export default component.exports